
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ServicesPreview = () => {
  return (
    <section className="py-24 lg:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <p className="font-inter text-xs uppercase tracking-widest text-taupe mb-4">
              Our Expertise
            </p>
            <h2 className="font-playfair text-5xl lg:text-6xl font-semibold text-charcoal leading-tight">
              Digital Strategy &<br />
              <em className="text-warm-gold">Program Mastery</em>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="font-inter text-base text-charcoal/70 leading-relaxed max-w-md">
              We combine cutting-edge digital strategy with proven program management excellence to deliver transformative results for modern enterprises.
            </p>
          </div>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Digital & Growth Services Card */}
          <motion.div
            whileHover={{ y: -8 }}
            transition={{ duration: 0.3 }}
            className="relative bg-gradient-to-br from-warm-white to-ivory rounded-3xl p-12 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="absolute top-8 right-8 w-12 h-12 bg-warm-gold rounded-full flex items-center justify-center cursor-pointer hover:bg-soft-bronze transition-colors duration-300">
              <i className="ri-arrow-right-up-line text-charcoal text-xl"></i>
            </div>
            
            <div className="absolute top-12 left-12 font-playfair text-9xl text-taupe/20 font-semibold select-none">
              01
            </div>
            
            <div className="relative mt-24">
              <h3 className="font-inter text-2xl font-bold text-charcoal mb-6">
                Digital & Growth Services
              </h3>
              
              <ul className="space-y-3 mb-8">
                {[
                  'Website Design & Development',
                  'Social Media Strategy & Management',
                  'Email Marketing & Automation',
                  'SEO & Analytics Optimization',
                  'Google Analytics Setup & Reporting',
                ].map((service, index) => (
                  <li key={index} className="flex items-start">
                    <span className="w-1.5 h-1.5 bg-warm-gold rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span className="font-inter text-base text-charcoal/80">{service}</span>
                  </li>
                ))}
              </ul>
              
              <p className="font-playfair text-lg italic text-taupe">
                Where brand meets performance.
              </p>
            </div>
          </motion.div>

          {/* Consulting & PMO Services Card */}
          <motion.div
            whileHover={{ y: -8 }}
            transition={{ duration: 0.3 }}
            className="relative bg-muted-taupe rounded-3xl p-12 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="absolute top-8 right-8 w-12 h-12 bg-warm-gold rounded-full flex items-center justify-center cursor-pointer hover:bg-soft-bronze transition-colors duration-300">
              <i className="ri-arrow-right-up-line text-charcoal text-xl"></i>
            </div>
            
            <div className="absolute top-12 left-12 font-playfair text-9xl text-charcoal/10 font-semibold select-none">
              02
            </div>
            
            <div className="relative mt-24">
              <h3 className="font-inter text-2xl font-bold text-charcoal mb-6">
                Consulting & PMO Services
              </h3>
              
              <ul className="space-y-3 mb-8">
                {[
                  'Digital Consulting & Strategy',
                  'PMO & Program Management',
                  'ISO / Process Optimization & SOPs',
                  'Smartsheet, Jira & Confluence Setup',
                  'Audit Prep & Operational Readiness',
                ].map((service, index) => (
                  <li key={index} className="flex items-start">
                    <span className="w-1.5 h-1.5 bg-warm-gold rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span className="font-inter text-base text-charcoal/80">{service}</span>
                  </li>
                ))}
              </ul>
              
              <p className="font-playfair text-lg italic text-charcoal/70">
                Leadership that delivers.
              </p>
            </div>
          </motion.div>
        </div>

        {/* View All Services Link */}
        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center font-inter text-base font-semibold text-charcoal hover:text-warm-gold transition-colors duration-300 cursor-pointer group"
          >
            View All Services
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
